import React from 'react'
import { ContentContainer, MainWrapper } from './style';
import OnboardingHomeBg from './components/OnboardingHomeBg';
import OnboardingInro from './components/OnboardingInro';
import RequestDetails from './components/RequestDetails';

function Request() {
    const REQUEST_DETAILS = {
        title: "Request Details",
        description: "Track all your self service request details",
    }
  return (
    <MainWrapper>
        <OnboardingHomeBg />
        <OnboardingInro title={REQUEST_DETAILS.title} description={REQUEST_DETAILS.description} />
        <ContentContainer>
            <RequestDetails />
        </ContentContainer>
    </MainWrapper>
  )
}

export default Request;
